'use strict';

var _ = require('lodash');
var MappedFaresInversionService = function MappedFaresInversionService($q, dataRetrieverService, dataRetrieverConstantsService, currentStateCriteriaService, SearchCriteriaRule) {
  function prepareKey(element) {
    return element.market + '+' + element.pos + '+' + element.cabinCode;
  }
  function prepareRange(element) {
    return [element.applicableDateRangeBegin.valueOf(), element.applicableDateRangeEnd.valueOf()];
  }
  function mergeGridDataWithMdc(data, faresFromGrid) {
    function isEqual(fromGrid, fromMdc) {
      return fares[j].userMappedFare !== undefined && fromGrid.className === fromMdc.className && fromGrid.pos === fromMdc.pos && fromGrid.market === fromMdc.market && fromGrid.applicableDateRangeBegin.isSame(fromMdc.applicableDateRangeBegin) && fromGrid.applicableDateRangeEnd.isSame(fromMdc.applicableDateRangeEnd);
    }
    var fares = _.cloneDeep(faresFromGrid);
    for (var i = 0, dataLength = data.length; i < dataLength; i++) {
      for (var j = 0, faresLength = fares.length; j < faresLength; j++) {
        if (isEqual(fares[j], data[i])) {
          data[i].totalFare = fares[j].userMappedFare;
          break;
        }
      }
      data[i]._key = prepareKey(data[i]);
      data[i]._range = prepareRange(data[i]);
    }
    return data;
  }
  function retrieveAllData(firstFareMarket) {
    var timeAndDateCategoryName = 'Time & Date';
    var marketCriterionName = 'Market';
    function getFaresSearchCriteria() {
      var criteria = currentStateCriteriaService.getSearchCriteria();
      var rules = criteria.rules;
      var searchWithNecessaryRules = _.filter(rules, function (rule) {
        return !(rule.category === timeAndDateCategoryName || rule.criterion === marketCriterionName);
      });
      searchWithNecessaryRules.push(new SearchCriteriaRule({
        category: 'Location',
        metaCategory: 'Mkt Location',
        shortCriterionName: 'Mkt',
        criterion: marketCriterionName,
        operator: '=',
        field: 'custom:faresMarket',
        searchContext: 'fares',
        leftOperand: [firstFareMarket],
        rightOperand: '',
        isReadOnly: true
      }));
      return searchWithNecessaryRules;
    }
    var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.MAPPED_FARES_INVERSION_MODE);
    dataRetriever.setCustomSearchCriteriaRules($q.when(getFaresSearchCriteria()));
    dataRetriever.defaultSortDefer.resolve();
    return dataRetriever.retrieveComponentData('mapped-fares-inversion');
  }
  function isInversion(data) {
    var prevElement;
    var possibleInversions = [];
    var result = {};
    function checkFaresInversionCondition(element, prevElement) {
      return element.classIndex > prevElement.classIndex && element.totalFare > prevElement.totalFare;
    }
    function checkIntersectionsAndInversionWithPreviousElements(elementToCheck) {
      _.forEach(possibleInversions, function (possibleInversion) {
        var test1 = possibleInversion._range;
        var test2 = elementToCheck._range;
        var maxOfLeftSides = _.max([test1[0], test2[0]]);
        var minOfRightSides = _.min([test1[1], test2[1]]);
        if (maxOfLeftSides <= minOfRightSides && checkFaresInversionCondition(elementToCheck, possibleInversion)) {
          result['' + possibleInversion._key + '*' + possibleInversion.className] = possibleInversion;
          result['' + elementToCheck._key + '*' + elementToCheck.className] = elementToCheck;
        }
      });
    }
    var dataWithClassProperty = _.filter(data, 'classIndex');
    dataWithClassProperty = _.filter(dataWithClassProperty, {
      ignoreForecastMapped: false
    });
    var sorterByMarket = _.sortBy(dataWithClassProperty, ['_key', 'classIndex']);
    _.forEach(sorterByMarket, function (element) {
      if (!prevElement || prevElement._key !== element._key) {
        possibleInversions.length = 0;
      } else {
        checkIntersectionsAndInversionWithPreviousElements(element);
      }
      possibleInversions.push(element);
      prevElement = element;
    });
    return _.values(result).length > 0;
  }
  function isMappedFaresInversion(faresRows) {
    var firstFare = _.first(faresRows);
    return retrieveAllData(firstFare.origin + '-' + firstFare.destination).then(function (data) {
      var mergedData = mergeGridDataWithMdc(data, faresRows);
      return isInversion(mergedData);
    });
  }
  return {
    isMappedFaresInversion: isMappedFaresInversion,
    isInversion: isInversion
  };
};
MappedFaresInversionService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'CurrentStateCriteriaService', 'SearchCriteriaRuleFactory'];
module.exports = MappedFaresInversionService;